import { render } from "./AdminAddUserB2C.vue?vue&type=template&id=1a6c4338&scoped=true"
import script from "./AdminAddUserB2C.vue?vue&type=script&lang=js"
export * from "./AdminAddUserB2C.vue?vue&type=script&lang=js"

import "./AdminAddUserB2C.vue?vue&type=style&index=0&id=1a6c4338&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6c4338"]])

export default __exports__